var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandCircleUp = function SvgExpandCircleUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "#e3e3e3",
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m350-394 130-130 130 130 43-42-173-173-173 173zM480-80q-83 0-156-31.5T197-197t-85.5-127T80-480t31.5-155.5 85.5-127 127-86T480-880t155.5 31.5 127 86 86 127T880-480t-31.5 156-86 127-127 85.5T480-80m0-60q141 0 240.5-99T820-480q0-141-99.5-240.5T480-820q-142 0-241 99.5T140-480q0 142 99 241t241 99m0-340"
  })));
};
export default SvgExpandCircleUp;